import React, { useEffect, useState } from 'react';
import ActionButton from "../../components/ActionButton";
import { CustomInput } from "reactstrap";
import { postRequest } from "sharedUtils/httpUtils";

const BrandTable = ({ apm, showModal, setIntegratedOff, mapmId, hostname }) => {
    const [state, setState] = useState([]);
    const [commissionSplitInvalid, setCommissionSplitInvalid] = useState(false);
    const [updateError, setUpdateError] = useState(false);

    // Initialize local state with commissionSplitDb snapshot
    useEffect(() => {
        const initialState = apm.map(item => ({
            ...item,
            commissionSplitDb: item.commissionSplit
        }));
        setState(initialState);
    }, [apm]);

    const onActiveChanged = async (id) => {
        let apms = [...state];
        apms[id].deleted = !apms[id].deleted;
        apms[id].autoShutoffDate = null;
        apms[id].hostname = hostname;

        setState(apms);

        const allDeleted = !(apms.find(({ deleted }) => deleted === false));
        if (allDeleted) {
            setIntegratedOff();
        }

        await postRequest('/api/AffiliateProgramManager/UpdateMerchantAffiliateProgramManagerDeleted', apms[id]);
    };

    const onEnableThirdChanceChanged = async (id) => {
        let apms = [...state];
        apms[id].enableThirdChance = !apms[id].enableThirdChance;
        apms[id].autoShutoffDate = null;
        apms[id].hostname = hostname;
        setState(apms);

        await postRequest('/api/AffiliateProgramManager/UpdateMerchantAffiliateProgramManagerDeleted', apms[id]);
    };

    const handleCommissionSplitInputChange = (id, value) => {
        let apms = [...state];
        apms[id].commissionSplit = value;
        setState(apms);
    };

    const onCommissionSplitChanged = async (id) => {
        setCommissionSplitInvalid(false);
        setUpdateError(false)

        let apms = [...state];
        let value = apms[id].commissionSplit;
        let splitValue = parseFloat(value);

        apms[id].hostname = hostname;


        if (isNaN(splitValue) || splitValue < 0 || splitValue > 1) {
            setCommissionSplitInvalid(true);
            return;
        }


        var updated = await postRequest('/api/AffiliateProgramManager/UpdateMerchantAffiliateProgramManagerDeleted', apms[id]);
        if (!!(updated)) {
            apms[id].commissionSplit = splitValue;
            apms[id].commissionSplitDb = splitValue;
            setState(apms);
        } else {
            setUpdateError(true)
        }
    };

    const displayTableRows = () => {
        return state.map((item, i) => {
            const lastRowClasses = i === state.length - 1 && i !== 0
                ? "d-md-flex justify-content-between align-items-center border-left-0 border-right-0 border-bottom-0"
                : "d-md-flex justify-content-between align-items-center border-0";

            return (
                <tr key={i} style={{ background: mapmId && item.merchantAffiliateProgramManagerId === mapmId ? "white" : "" }}>
                    <td>{item?.affiliateProgramManagerName}</td>
                    <td>
                        <CustomInput
                            id={`active-${i}`}
                            type="switch"
                            name={`active-${item?.affiliateProgramManagerName}`}
                            onChange={() => onActiveChanged(i)}
                            checked={!item.deleted}
                        />
                    </td>
                    <td>
                        <CustomInput
                            id={`thirdChance-${i}`}
                            type="switch"
                            name={`thirdChance-${item?.affiliateProgramManagerName}`}
                            onChange={() => onEnableThirdChanceChanged(i)}
                            checked={item.enableThirdChance}
                        />
                    </td>
                    <td>{`${item?.commission * 100}%`}</td>
                    <td>
                        <div className="input-group" style={{ maxWidth: 120, cursor: parseFloat(item.commissionSplit) === parseFloat(item.commissionSplitDb) ? "" : "pointer" }}>
                            <input
                                type="number"
                                min={0}
                                max={1}
                                step={0.0001}
                                className="form-control"
                                value={item.commissionSplit ?? ""}
                                onChange={e => handleCommissionSplitInputChange(i, e.target.value)}
                                style={{ minWidth: 80 }}
                            />
                            <div className="input-group-append">
                                <button
                                    className="btn brandOrange"
                                    type="button"
                                    onClick={() => onCommissionSplitChanged(i)}
                                    disabled={parseFloat(item.commissionSplit) === parseFloat(item.commissionSplitDb)}
                                >
                                    Update
                                </button>
                            </div>
                        </div>
                    </td>
                    <td>{'refreshStatus' in item ? item.refreshStatus : "N/A"}</td>
                    <td style={{ textAlign: "left" }}>
                        {item?.feedLastProcessed
                            ? <div className="pb-0">{new Date(item.feedLastProcessed).toLocaleDateString()}</div>
                            : "N/A"}
                    </td>
                    <td className={lastRowClasses} style={{ minHeight: "100px" }}>
                        {item?.dateLastRefreshed
                            ? new Date(item.dateLastRefreshed).toLocaleDateString()
                            : "N/A"}
                        <div className="d-flex align-items-center">
                            {item.internalId ? (
                                <ActionButton
                                    className="btn btn-primary"
                                    onClick={(e) => showModal(e, item.affiliateProgramManagerId)}
                                >
                                    Refresh
                                </ActionButton>
                            ) : (
                                <ActionButton isDisabled={true} className="btn btn-primary">
                                    Refresh
                                </ActionButton>
                            )}
                        </div>
                    </td>
                </tr>
            );
        });
    };

    return (
        <div className="container">
            <div className="row mt-0 mx-0 pt-3 pb-5">
                <div className="table-responsive product-table" style={{ overflow: "auto" }}>
                    <table className="table" style={{ backgroundColor: '#e9ecef' }}>
                        <thead>
                            <tr>
                                <th><strong>Name</strong></th>
                                <th><strong>Active</strong></th>
                                <th><strong>Third Chance</strong></th>
                                <th><strong>Commission</strong></th>
                                <th><strong>Commission Split</strong></th>
                                <th><strong>Refresh Status</strong></th>
                                <th><strong>Feed Last Updated</strong></th>
                                <th><strong>Date Last Refreshed</strong></th>
                            </tr>
                        </thead>
                        <tbody>
                            {displayTableRows()}
                        </tbody>
                    </table>
                    <p style={{ color: "red", display: commissionSplitInvalid ? "" : "none" }}>
                        Enter a valid commission split between 0 and 1 (e.g., 0.70 for 70%) before Updating
                    </p>
                    <p style={{ color: "red", display: updateError ? "" : "none" }}>
                        Error while updating Commission Split - TRY AGAIN
                    </p>
                </div>
            </div>
        </div>
    );
};

export default BrandTable;
